import { AssetOwnershipMeta } from '/@/modules/asset/models/meta/AssetOwnershipMeta';
import { VehicleType } from '/@/modules/asset/enums/VehicleType';
import Lang from '/@/modules/core/app/services/Lang';

export class VehicleAssetMeta extends AssetOwnershipMeta {
  /**
   * @var {string}
   */
  vehicleMakeId;

  /**
   * @var {VehicleMake}
   */
  vehicleMake;

  /**
   * @var {string}
   */
  vehicleModelId;

  /**
   * @var {VehicleModel}
   */
  vehicleModel;

  /**
   * @var {string}
   */
  year;

  /**
   * @var {?number}
   */
  sharePercentage;

  /**
   * @var {?string}
   */
  category;

  /**
   * @var {?string}
   */
  recreationalProductType;

  /**
   * @var {?string}
   */
  recreationalProductModel;

  /**
   * @var {?string}
   */
  vehicleIdentificationNumber;

  /**
   * @var {?number}
   */
  mileage;

  constructor(model = {}) {
    super(model);

    this.vehicleMakeId = model.vehicleMakeId;
    this.vehicleModelId = model.vehicleModelId;
    this.year = model.year;
    this.sharePercentage = model.sharePercentage;
    this.category = model.category;
    this.recreationalProductType = model.recreationalProductType;
    this.recreationalProductModel = model.recreationalProductModel;
    this.vehicleIdentificationNumber = model.vehicleIdentificationNumber;
    this.mileage = model.mileage;
  }

  /**
   * @returns {string}
   */
  get categoryTitle() {
    const categoryTitle = VehicleType.getByKey(this.category)?.value;
    return categoryTitle ? `${categoryTitle} ${Lang.t('asset.vehicle-asset')}` : null;
  }

  /**
   * @returns {string}
   */
  get title() {
    if (this.category) {
      return this.categoryTitle;
    }
    return `${this.vehicleMake?.name} ${this.vehicleModel?.name} ${this.year}`;
  }

  /**
   * @var {boolean}
   */
  get hasPercentShare() {
    return this.sharePercentage >= 0 && this.sharePercentage <= 100;
  }

  /**
   * @returns {boolean}
   */
  get hasVehicleTitle() {
    return !!(
      this.categoryTitle ||
      (this.vehicleMake?.name && this.vehicleModel?.name && this.year)
    );
  }
}
